// extracted by mini-css-extract-plugin
export default {"steps":"tx-z","header":"ux-z","description":"vx-z"};